import Vue from 'vue';

Vue.component('report-wizard-index', () =>
    import(/* webpackChunkName: 'report-wizard-index' */ './report-wizard-index.vue'),
);
